













import {Component, Vue, Prop} from 'vue-property-decorator'
import {DistanceOverride} from '@/lib/kepler/interfaces'
import DataTable from '@/components/proxy/DataTable.vue'
import Container from '@/components/proxy/Container.vue'

@Component({
  name: 'DistanceOverrides',
  components: {Container, DataTable},
})
export default class DistanceOverrides extends Vue {
  @Prop() public distanceOverrides!: DistanceOverride[]

  get distanceDiscountHeaders() {
    return [
      {
        text: this.$t(`common.min_distance`),
        align: 'center',
        sortable: false,
        value: 'name',
      },
      {
        text: this.$t(`activities.plans.cost_per_km`),
        align: 'center',
        sortable: false,
        value: 'name',
      },
    ]
  }

}
